export default __webpack_public_path__ + "static/tag-dont-5-light-e7e180b2ed33a2b7a7896e89d6f3ad0f687342d86a33fa61376d8d60ef608b0f.png";